module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n\n<nav-bar></nav-bar>\n\n<router-outlet></router-outlet>\n\n<mdg-footer></mdg-footer>\n\n"


//////////////////
// WEBPACK FOOTER
// /Users/mdg/Source/markclimb/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main